// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"47863806","492":"71b36ac9"}[chunkId] + ".chunk.js";
};